import React from 'react';
import { urls } from '../../constants';
import i18next from "../../i18n";
import { History } from '../helpers/History';
import { AccountFormHeader } from './AccountFormHeader';
export function SessionEndedPage(props) {
    return (<div className="form-page" >
        <div className="form-block large-form">
            <AccountFormHeader className="form-header-subtitle-right form-subtitle" />
            <div className="form-content">
                <div className="form-group">
                    <div className="info-message-title">{i18next.t("attentionTitle")}</div>
                    <div className="info-message">{i18next.t("sessionEndedMessage")}</div>
                </div>
                <div className="form-group form-group__last"><button className="btn btn-primary" onClick={() => History.push(urls.loginPageUrl)}>{i18next.t("ok")}</button></div>
            </div>
        </div>
    </div>);
}